// FLAGS: legacy
// The store's root reducer. One slice only — `authReducers` — so the Redux tree holds nothing but the
// session; everything else moved to React Query.
import { combineReducers } from "redux";
import authReducers from "./authReducers";

export default combineReducers({
  authReducers,
});
